function normalizePath(path: string): string {
  const trimmedPath = path.trim()
  if (trimmedPath === '') {
    return '/'
  }
  const normalizedPath = trimmedPath.replace(/\/+$/, '')
  return normalizedPath.length > 0 ? normalizedPath : '/'
}

export function matchesExpectedPath(currentPath: string, expectedPath: string): boolean {
  const normalizedCurrentPath = normalizePath(currentPath)
  const normalizedExpectedPath = normalizePath(expectedPath)
  if (normalizedExpectedPath === '/') {
    return normalizedCurrentPath === '/'
  }
  return (
    normalizedCurrentPath === normalizedExpectedPath ||
    normalizedCurrentPath.startsWith(`${normalizedExpectedPath}/`)
  )
}
